import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useConversations } from '../../contexts/CommunicationNavigationContext';
import { needsCommunicationAttention } from '../../services/communications.service';

export default function CommunicationProfileLink({ children, onClick }: { children: ReactNode; onClick?: () => void }) {
  const { rows } = useConversations();
  const count = rows.filter(needsCommunicationAttention).length;
  const label = `Communications: ${count ? `${count} open request${count === 1 ? '' : 's'}` : 'no open requests'} needing your attention`;
  return <Link to="/communications" onClick={onClick} aria-label={label} title={label}
    className="relative block shrink-0 rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2">
    {children}
    {count > 0 && <span aria-hidden="true" className="absolute -right-2 -top-2 flex size-5 items-center justify-center rounded-full bg-red-600 text-[10px] font-bold leading-none text-white ring-2 ring-white dark:ring-gray-900">{count > 99 ? '99+' : count}</span>}
  </Link>;
}
